import { gql } from '@apollo/client';
import { useAuth0 } from '@auth0/auth0-react';

import { Server } from '../../apollo/types';
import { TRANSCRIPTION_CONSENT_COPY_PILOT_KEY } from '../../provider/session-recording/constants';
import { useAppDependenciesContext } from '../../state';

type MomentumPilotFeatureForPatientQuery = {
  momentumPilotFeatureForPatient: {
    key: string;
    enabled: boolean;
  };
};

type MomentumPilotFeatureForPatientQueryVariables = {
  patientShortId: string;
  key: string;
  shouldSkipAppVersionCheck: boolean;
};

export const MOMENTUM_PILOT_FEATURE_FOR_PATIENT_QUERY = gql`
  query MomentumPilotFeatureForPatient($patientShortId: String!, $key: String!, $shouldSkipAppVersionCheck: Boolean) {
    momentumPilotFeatureForPatient(
      patientShortId: $patientShortId
      key: $key
      shouldSkipAppVersionCheck: $shouldSkipAppVersionCheck
    ) {
      key
      enabled
    }
  }
`;

export function useShowRefreshedClientConsentCopy(patientShortId: string | undefined): boolean {
  const { isAuthenticated } = useAuth0();
  const { useQuery } = useAppDependenciesContext();

  const { data } = useQuery<MomentumPilotFeatureForPatientQuery, MomentumPilotFeatureForPatientQueryVariables>(
    MOMENTUM_PILOT_FEATURE_FOR_PATIENT_QUERY,
    {
      variables: {
        patientShortId: patientShortId ?? '',
        key: TRANSCRIPTION_CONSENT_COPY_PILOT_KEY,
        shouldSkipAppVersionCheck: true,
      },
      skip: !isAuthenticated || !patientShortId,
      context: {
        server: Server.MONOLITH,
      },
    },
  );

  return data?.momentumPilotFeatureForPatient?.enabled ?? false;
}
